import React from 'react';
import SvgIcon from './SvgIcon';

const BambooHRLogo = props => (
    <SvgIcon viewBox="0 0 533.333 533.333" {...props}>
        <path
            fill="#69c52f"
            style={{
                fillOpacity: 1,
                fillRule: 'evenodd',
                stroke: 'none'
            }}
            d="M4000 2000C4000 895.441 3104.57 0 2000 0 895.434 0 0 895.441 0 2000c0 1104.57 895.434 2000 2000 2000 1104.57 0 2000-895.43 2000-2000zm-1640.79 348.21c-238.03 0-365.64-81.7-455.12-170.52l-24.4-25.61-.07 797.74h-205.63v-1305.6c0-401.74 309.45-652.048 664.52-652.048 391.16 0 687.28 301.018 687.28 687.968 0 359.28-308.87 668.07-666.58 668.07zM1577 2083.27l-91.26 299.05c-54.47 157.29-70.59 247.83-224.06 409.88-52.56 55.59-251.53 177.92-226.83 151.23 252.14-272.17 381.09-601.96 430.83-693.56-45.68 55.47-99.23 105.28-160.31 167.24-52.02 52.76-106.35 100.36-158 132.26-33.97 21.05-53.05 32.65-87.52 50.5-155.346 80.7-305.932 129.55-363.745 143.98-70.601 17.58-140.203 22.17-140.203 22.17s225.118-190.05 321.547-311.03c96.469-120.92 194.871-229.36 303.651-273.69 108.77-44.35 146.62-57.05 232.15-70 73.77-11.12 163.75-28.03 163.75-28.03zm761.51-903.69c-258.29 0-476.87 203.66-476.87 476.44 0 272.94 184.3 497.1 481.5 497.1 297.27 0 472.4-240.33 472.4-492.06 0-273.86-185.33-481.48-477.03-481.48"
            transform="matrix(.13333 0 0 -.13333 0 533.333)"
        />
        <path
            fill="#69c52f"
            style={{
                fillOpacity: 1,
                fillRule: 'nonzero',
                stroke: 'none'
            }}
            d="M3748.36 395.941c1.08-2.519 2.11-4.91 3.1-7.16a55.214 55.214 0 0 0 2.56-7.14c.91 2.519 1.71 4.898 2.43 7.14.72 2.25 1.8 4.641 3.25 7.16l45.62 81.797c1.61 2.344 3.15 3.883 4.58 4.602 1.45.711 3.6 1.07 6.49 1.07H3845V323.59h-29.7v98.531l2.43 20.258-49.4-90.707c-2.34-5.043-6.29-7.563-11.88-7.563h-4.86c-5.58 0-9.44 2.52-11.61 7.563l-49.67 89.898 2.16-19.449V323.59h-29.69v159.82h28.61c3.06 0 5.22-.359 6.48-1.07 1.26-.719 2.87-2.258 4.85-4.602zm-111.5 87.469v-28.351h-48.6V323.59h-34.01v131.469h-48.6v28.351h131.21"
            transform="matrix(.13333 0 0 -.13333 0 533.333)"
        />
    </SvgIcon>
);

BambooHRLogo.displayName = 'BambooHRLogoIcon';

export default BambooHRLogo;
